module.exports = __webpack_public_path__ + "img/SWEAT - Intensity & Endurance.35c8a6b4.png";